import { DeeplinkFlowConfig } from './types';

/**
 * Supported deep-link params:
 * - po: flow identifier, must match a key in DEEPLINK_FLOWS.
 * - id: target item/category id for the flow.
 * - sc: target sub/super-category id (Templates flow).
 * - pa: post action inspector type, chained after the initial UI open.
 */
export const DEEPLINK_PARAM_KEYS = ['po', 'id', 'sc', 'pa'];

/**
 * Deeplink flow registry.
 * To add a new flow:
 * 1) Add a new key in this map (same value used by `po`).
 * 2) Add/update its DeeplinkFlowType in `types.ts`.
 * 3) Handle the mapped actionType in the deeplink resolver.
 */
export const DEEPLINK_FLOWS: Record<string, DeeplinkFlowConfig> = {
  TEMPLATES:      { type: 'TEMPLATES',      actionType: 'open_popover' },
  GRAPHICS:       { type: 'GRAPHICS',       actionType: 'open_popover' },
  FONT_TEXT:      { type: 'FONT_TEXT',      actionType: 'open_popover' },
  QUICK_TUTORIAL: { type: 'QUICK_TUTORIAL', actionType: 'open_modal' },
};
